import styled from "styled-components";

import { scaleOnClickAnim, whiteBgOnClickAnim } from "../../animations";

export const OuterDiv = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const Header = styled.div`
  text-transform: capitalize;
  font-size: 20px;
  margin-bottom: 72px;
  white-space: nowrap;
  @media only screen and (min-width: 375px) {
    font-size: 24px;
  }
`;
export const BallContainer = styled.div`
  display: grid;
  grid-template-columns: auto auto auto auto auto;
  /* grid-row-gap: 4px;
  grid-column-gap: 4px; */
  margin: 32px auto;
  text-align: center;
  grid-row-gap: 9px;
  grid-column-gap: 9px;
  @media only screen and (min-width: 375px) {
    grid-row-gap: 9px;
    grid-column-gap: 9px;
  }
`;
export const Ball = styled.div`
  border: solid 3px transparent;
  border-radius: 50%;
  /* width: 48px;
  height: 48px; */
  display: flex;
  justify-content: center;
  align-items: center;
  /* font-size: 16px; */
  cursor: pointer;
  position: relative;
  width: 56px;
  height: 56px;
  font-size: 20px;
  span {
    border: solid 3px #ffb000;
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }
  p {
    z-index: 1;
  }
  &&.selected {
    animation: ball 0.25s forwards;
    p {
      animation: text 0.25s forwards;
    }
    span {
      background: #ffb000;
      animation: backgroundA 0.25s forwards;
    }
  }
  @keyframes text {
    0% {
      transform: scale(1);
      color: #ffb000;
      animation-timing-function: cubic-bezier(0.33, 1, 0, 0);
    }
    50% {
      transform: scale(0.25);
      color: #4199ba;
      animation-timing-function: cubic-bezier(0.1, 0, 0, 1);
    }
    100% {
      transform: scale(1);
      color: #4199ba;
    }
  }
  @keyframes ball {
    0% {
      transform: scale(1);
      border: solid 3px transparent;
      animation-timing-function: cubic-bezier(0.33, 1, 0, 0);
    }
    25% {
      transform: scale(0.65);
      border: none;
      animation-timing-function: cubic-bezier(0.1, 0, 0, 1);
    }
    65% {
      transform: scale(1);
    }
  }
  @keyframes backgroundA {
    0% {
      opacity: 0;
      border: solid 3px #ffb000;
      animation-timing-function: cubic-bezier(0.25, 0, 0.2, 1);
    }
    25% {
      opacity: 1;
      border: none;
    }
  }
  /* @media only screen and (min-width: 375px) {
    width: 56px;
    height: 56px;
    font-size: 20px;
  } */
`;
export const Button = styled.div`
  background: #ffb000;
  border: solid 3px #ffb000;
  border-radius: 38px;
  /* height: 48px; */
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  color: #4199ba;
  text-transform: uppercase;
  font-size: 20px;
  /* margin-top: 112px; */
  position: relative;
  cursor: pointer;
  height: 56px;
  margin-top: 70px;
  pointer-events: ${(p) => (p.isDisabled ? "none" : "auto")};
  :after {
    content: "";
    position: absolute;
    height: 100%;
    width: 100%;
    transform: scale(1);
    background: #ffffff;
    border: solid 3px #ffffff;
    border-radius: 38px;
    opacity: 0;
    right: 50%;
    bottom: 50%;
    transform: translate(50%, 50%);
    width: 100%;
    height: 100%;
    animation: ${(p) => (p.setA ? whiteBgOnClickAnim : null)};
    animation-duration: 0.5s;
  }
  animation: ${(p) => (p.setA ? scaleOnClickAnim : null)};
  animation-duration: 0.5s;
  /* @media only screen and (min-width: 375px) {
    height: 56px;
    margin-top: 130px;
  } */
`;
